import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('codeInputModalCtrl', [
    '$rootScope',
    '$scope',
    'BAS_SPLASH',
    'close',
    'basModalConfig',
    codeInputModalCtrl
  ])

/**
 * @param $rootScope
 * @param $scope
 * @param {BAS_SPLASH} BAS_SPLASH
 * @param close
 * @param {BasInputModalConfig} basInputModalConfig
 * @param {string} basInputModalConfig.title
 * @param {TBasModalInput[]} basInputModalConfig.inputs
 * @param {string} basInputModalConfig.saveTextId
 * @param {string} basInputModalConfig.errorTextId
 */
function codeInputModalCtrl (
  $rootScope,
  $scope,
  BAS_SPLASH,
  close,
  basInputModalConfig
) {
  var modal = this

  var _listeners = []

  var CSS_INPUT_INVALID = 'im-input-invalid'

  modal.closeModal = closeModal
  modal.save = save
  modal.enterCharacter = enterCharacter
  modal.backSpace = backSpace
  modal.clear = clear

  modal.basInputModalConfig = basInputModalConfig

  modal.title = basInputModalConfig.title
  modal.subTitle = basInputModalConfig.subTitle
  modal.inputValue = ''
  modal.saveTextId = basInputModalConfig.saveTextId

  modal.css = {}

  init()

  function init () {

    _listeners.push($rootScope.$on(
      BAS_SPLASH.EVT_SPLASH_VISIBILITY_CHANGED,
      _onSplashVisibility
    ))

    $scope.$on('$destroy', _onDestroy)

    _resetCss()

    _initInput()
    _onInputChanged()
  }

  function _initInput () {

    if (
      Array.isArray(basInputModalConfig.inputs) &&
      basInputModalConfig.inputs[0]
    ) {

      const input = basInputModalConfig.inputs[0]

      modal.inputValue = BasUtil.isNEString(input.initialValue)
        ? input.initialValue
        : ''
    }
  }

  function _onInputChanged () {

    _syncValid()
  }

  function _syncValid () {

    modal.css[CSS_INPUT_INVALID] =
      modal.inputValue.length !== modal.basInputModalConfig.inputs[0]?.length
  }

  function closeModal (reason) {

    if (
      !modal.basInputModalConfig ||
      modal.basInputModalConfig.allowDismiss
    ) {

      close(reason)
    }
  }

  function save () {

    if (!modal.css[CSS_INPUT_INVALID]) close(modal.inputValue, 0)
  }

  function enterCharacter (character) {

    modal.inputValue = `${modal.inputValue}${character}`.slice(0, modal.basInputModalConfig.inputs[0].length)
    _onInputChanged()
    if (
      modal.basInputModalConfig.obfuscate &&
      modal.inputValue.length === modal.basInputModalConfig.inputs[0].length
    ) {
      setTimeout(save, 350)
    }
  }

  function backSpace () {

    modal.inputValue = modal.inputValue.slice(0, modal.inputValue.length - 1)
    _onInputChanged()
  }

  function clear () {

    modal.inputValue = ''
    _onInputChanged()
  }

  function _onSplashVisibility () {

    close()
  }

  function _resetCss () {

    modal.css[CSS_INPUT_INVALID] = false
  }

  function _onDestroy () {

    BasUtil.executeArray(_listeners)
    _listeners = []
  }
}
